import { SharedErrors } from 'web_core_library';

export type IStatState = {
  payload: any;
};

export type ITutorialState = { payload: any; lastEdit: number };

export class UnityError extends SharedErrors.BaseError {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, UnityError.prototype);
    this.feature = 'Unity';
    this.errorType = SharedErrors.ALERT_TYPE;
  }
}

export interface IInitUnityPayload {
  preloading?: boolean;
  basePath?: string;
}
